//
// DF: Plugins avec des fonctions globales pour le projet
//

import moment from 'moment'

const Utils = {
  install(Vue, options) {
    // ----------------------------
    // Utilitaires format vuelidate
    // Exemple: $vErr($v.listeFavoris.nom, 'Le nom')
    // ----------------------------
    Vue.prototype.$vErr = function (field, texte, min, max) {
      const errors: string[] = []
      if (!field.$dirty) return errors
      if ('email' in field) {
        !field.email && errors.push("L'adresse courriel est invalide")
      }
      if ('required' in field) {
        !field.required && errors.push(`${texte} est obligatoire`)
      }
      if ('minLength' in field) {
        !field.minLength &&
          errors.push(`La longueur doit être de ${min} caractères minimum`)
      }
      if ('maxLength' in field) {
        !field.maxLength &&
          errors.push(`La longueur ne doit pas dépasser ${max} caractères`)
      }
      return errors
    }

    // -----------------------
    // Utilitaires fichiers
    // -----------------------
    Vue.prototype.$toBase64 = async function (file) {
      // https://simon-schraeder.de/posts/filereader-async/
      let contentBuffer = await this.$readFileAsync(file)
      return btoa(contentBuffer)
    }
    Vue.prototype.$readFileAsync = async function readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => {
          resolve(reader.result)
        }
        reader.readAsBinaryString(file)
      })
    }

    // -----------------------
    // Formattage erreurs axios
    // -----------------------
    Vue.prototype.$fmtApiErr = function (resp) {
      return `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
    }

    Vue.prototype.$fmtAxiosErr = function (error) {
      if (error.response) {
        let resp = error.response
        return `Erreur retour API: ${resp.status} - ${resp.statusText}`
      }
      // if (error.request) {
      //   let req = error.request
      //   return `Erreur appel API (req): ${req.status} - ${req.statusText}`
      // }

      return `Erreur technique API: ${error.message}`
    }

    // -----------------------
    // Formattage Dates
    // -----------------------

    Vue.prototype.$fmtTsEnDate = function (timestamp) {
      if (timestamp == null) {
        return null
      }
      return moment(timestamp).format('YYYY-MM-DD')
    }

    Vue.prototype.$fmtDateHeure = function (timestamp) {
      if (timestamp == null) {
        return null
      }
      return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
    }

    Vue.prototype.$fmtTsEnDateEcrite = function () {
      return moment(new Date())
        .locale('fr')
        .format('LL')
    }

    Vue.prototype.$fmtDateIsoSansUTCTimeStamp = function (timestamp) {
      if (timestamp == null) {
        return null
      }
      return moment(timestamp)
        .toISOString()
        .replace('Z', '')
    }
    // -----------------------
    // Formattage Montants
    // -----------------------
    Vue.prototype.$fmtDecimal = function (montant, decimales) {
      //  console.log('$fmtDecimal=' + montant)
      let d = decimales == null ? 2 : decimales
      let m = montant == null ? 0 : montant
      return Number(m)
        .toFixed(d)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
  }
}

export default Utils
